import { useSyncExternalStore } from 'react';
const natural = (a, b) => String(a || '').localeCompare(String(b || ''), undefined, { numeric: true, sensitivity: 'base' });
// NT0367-N, NT0367, NT0367-E and NT.367 → "NT367": letters + first number, ignoring separators, leading zeros and endings.
export const baseNo = (no) => { const m = String(no || '').toUpperCase().match(/^([A-Z]*)[^A-Z0-9]*0*(\d+)/); return m ? `${m[1]}${m[2]}` : String(no || '').toUpperCase().trim(); };

// Within a group, pieces follow the super admin's jewellery type order; unlisted types go last.
export const DEFAULT_TYPE_ORDER = ['Necklace', 'Pendant', 'Earrings', 'Bangle', 'Bracelet', 'Ring', 'Tika', 'Nose Pin'];
let typeOrder = DEFAULT_TYPE_ORDER;
const subs = new Set();
export function setTypeOrder(list) { typeOrder = Array.isArray(list) ? list : DEFAULT_TYPE_ORDER; subs.forEach((f) => f()); }
export const getTypeOrder = () => typeOrder;
export const useTypeOrder = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, getTypeOrder);
// "Earrings" = "earring", "Pendent" ~ "Pendant", "Tikka" ~ "Tika": exact name first, then the first 3 letters.
const stem = (t) => String(t || '').toLowerCase().replace(/[^a-z]/g, '').replace(/s$/, '');
const typeRank = (t) => {
  const s = stem(t);
  let i = typeOrder.findIndex((o) => stem(o) === s);
  if (i < 0 && s.length >= 3) i = typeOrder.findIndex((o) => stem(o).slice(0, 3) === s.slice(0, 3));
  return i < 0 ? typeOrder.length : i;
};

// Page No. groups first (ascending, header "No. 12"); pieces without one grouped by matching jewellery number.
export function groupPieces(list, pageOf, noOf, typeOf = () => '') {
  const by = new Map();
  list.forEach((x) => {
    const page = pageOf(x) || '';
    const key = page ? `P${page}` : `J${baseNo(noOf(x))}`;
    if (!by.has(key)) by.set(key, { page, base: page ? '' : baseNo(noOf(x)), items: [] });
    by.get(key).items.push(x);
  });
  return [...by.values()].sort((a, b) => (!!a.page !== !!b.page ? (a.page ? -1 : 1) : natural(a.page || a.base, b.page || b.base)))
    .map((g) => ({ ...g, label: g.page ? `No. ${g.page}` : `Jewellery no. ${g.base}`, items: g.items.sort((a, b) => typeRank(typeOf(a)) - typeRank(typeOf(b)) || natural(noOf(a), noOf(b))) }));
}

// Flat list in export order: groups, then type order inside each group.
export const orderPieces = (list, pageOf, noOf, typeOf) => groupPieces(list, pageOf, noOf, typeOf).flatMap((g) => g.items);
